export default () => ({
  initialized: false,
  init() {
    if (this.initialized) return;
    this.initialized = true;

    //all heading options to select through i.e subscription,otp's etc
    const GBBHeadingButtons = document.querySelectorAll('.gbb-offering-heading');
    for (let i = 0; i < GBBHeadingButtons.length; i++) {
      GBBHeadingButtons[i].addEventListener('click', function () {
        //only allow selection of a a non selected button(only 2 atm)
        if (this.classList.contains('selected')) return;
        updateGBBSelected(GBBHeadingButtons, this);

        //determine if we are showing a subscription or otp
        const isSubscription = this.classList.contains('subscription');
        //update view of offerings depending on type of purchase
        const hideSelections = document.querySelector(`.gbb-offering-info${isSubscription ? '.otp' : '.subscription'}`);
        if (hideSelections) hideSelections.classList.remove('selected');
        const showSelections = document.querySelector(`.gbb-offering-info${isSubscription ? '.subscription' : '.otp'}`);
        if (showSelections) showSelections.classList.add('selected');

        updateGBBImage();
      });
    }

    // all subscription offering click functions
    const GBBSubscriptionOfferings = document.querySelectorAll('.gbb-offering-info.subscription .gbb-product-offering');
    for (let k = 0; k < GBBSubscriptionOfferings.length; k++) {
      GBBSubscriptionOfferings[k].addEventListener('click', function () {
        if (this.classList.contains('selected')) return;
        updateGBBSelected(GBBSubscriptionOfferings, this);
        updateGBBImage();
      });
    }

    // all otp offering click functions
    const GBBOTPOfferings = document.querySelectorAll('.gbb-offering-info.otp .gbb-product-offering');
    for (let l = 0; l < GBBOTPOfferings.length; l++) {
      GBBOTPOfferings[l].addEventListener('click', function () {
        if (this.classList.contains('selected')) return;
        updateGBBSelected(GBBOTPOfferings, this);
        updateGBBImage();
      });
    }

    const GBBVariantSelections = document.querySelectorAll(
      '.gbb-product-variant-selector .gbb-product-variant-selection',
    );
    for (let l = 0; l < GBBVariantSelections.length; l++) {
      GBBVariantSelections[l].addEventListener('click', function () {
        if (this.classList.contains('selected')) return;
        const selectedOption = document.querySelector('.gbb-offering-heading.selected');
        const isSubscription = selectedOption.classList.contains('subscription');
        const GBBCurrentVariantSelections = document.querySelectorAll(
          `.gbb-offering-info${isSubscription ? '.subscription' : '.otp'} .gbb-product-variant-selector .gbb-product-variant-selection`,
        );
        updateGBBSelected(GBBCurrentVariantSelections, this);
        updateGBBImage();
      });
    }
    updateGBBImage();
  },
});

function updateGBBSelected(otherElements, updateElement) {
  //unselect all other buttons
  for (let j = 0; j < otherElements.length; j++) {
    otherElements[j].classList.remove('selected');
  }
  //mark as selected
  if (updateElement) updateElement.classList.add('selected');
}

function updateGBBImage() {
  const selectedOption = document.querySelector('.gbb-offering-heading.selected');
  if (!selectedOption) return;

  //find right option then get their selected
  const isSubscription = selectedOption.classList.contains('subscription');

  const imageContainer = document.querySelector('.gbb-img-container');
  const imageElement = imageContainer.querySelector('img');

  if (isSubscription && !imageContainer.classList.contains('sub')) {
    imageContainer.classList.remove('otp');
    imageContainer.classList.add('sub');
  } else if (!isSubscription && !imageContainer.classList.contains('otp')) {
    imageContainer.classList.remove('sub');
    imageContainer.classList.add('otp');
  }

  const hasVariantSelector = document.querySelector(
    `.gbb-offering-info${isSubscription ? '.subscription' : '.otp'} .gbb-product-offering.selected .gbb-product-variant-selector .gbb-product-variant-selection.selected`,
  );

  if (hasVariantSelector) {
    const variantName = document.querySelector(
      `.gbb-offering-info${isSubscription ? '.subscription' : '.otp'} .gbb-product-offering.selected .gbb-curr-variant`,
    );
    variantName.innerText = hasVariantSelector.getAttribute('data-var-name');
    //if (!imageElement.classList.contains('hidden')) imageElement.classList.add('hidden');
    imageContainer.setAttribute('data-var', hasVariantSelector.getAttribute('data-var-id'));
    imageElement.classList.remove('hidden');
    imageElement.classList.add('invisible');

    const variantLinkElement = document.querySelector(`.gbb-offering-info${isSubscription ? '.subscription' : '.otp'} .gbb-product-offering.selected .gbb-atc a`);

    if (!variantLinkElement) return;
    const variantLink = variantLinkElement.getAttribute('data-href');
    if (!variantLink) return;
    const variantLinkOptions = variantLinkElement.getAttribute('data-dynamic');
    const variantLinkArray = variantLinkOptions.split(',');
    let variantMatch = null;

    for (let i = 0; i < variantLinkArray.length; i++) {
      if (variantLinkArray[i].indexOf(hasVariantSelector.getAttribute('data-var-id')) !== -1) {
        variantMatch = variantLinkArray[i];
        break;
      }
    }

    if (!variantMatch) return;

    const variantMatchItems = variantMatch.split('|');

    let newLink = variantLink.replace('%varid%', variantMatchItems[0]);
    newLink = newLink.replace('%vardiscount%', variantMatchItems[1]);
    if(newLink)
      variantLinkElement.setAttribute('href', newLink);

  } else {
    imageContainer.removeAttribute('data-var');
    const optionElement = document.querySelector(
      `.gbb-offering-info${isSubscription ? '.subscription' : '.otp'} .gbb-product-offering.selected`,
    );
    const newImage = optionElement.getAttribute('data-image');

    imageElement.setAttribute('srcset', newImage);
    imageElement.setAttribute('src', newImage);
    imageElement.classList.remove('hidden');
  }
}
